import { Branch } from "@/commons/interface/project/branch"
import { bimAxios } from "@/config/axios"
import { AxiosResponse } from "axios"

export function createBranch(branch: Branch, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.post(`/branches`, branch, {
        params: {
            ...params,
        }
    })
}

export function findBranchesByModelUuid(modelUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.get(`/models/${modelUuid}/branches`, {
        params: {
            ...params,
        }
    })
}


export function updateBranch(uuid: string, branch: Branch, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.put(`/branches/${uuid}`, branch, {
        params: {
            ...params,
        }
    })
}

export function deleteBranch(uuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.delete(`/branches/${uuid}`, {
        params: {
            ...params,
        }
    })
}